import { Validator, Success, Failure, ValidationError } from '@totalsoft/pure-validations';
import i18next from 'i18next';
import moment from 'moment';

export const filterConditionContainsConditionNumbers = conditionNumbers =>
  Validator(function listEqual(filterCondition) {
    if (!filterCondition) return Success;

    const numbersInFilterCondition = filterCondition.match(/\d+/g);

    if (!numbersInFilterCondition) return Failure(ValidationError(i18next.t('Validations.Generic.FilterConditionInvalid')));

    if (numbersInFilterCondition.every(x => conditionNumbers.includes(parseInt(x)))) return Success;
    else return Failure(ValidationError(i18next.t('Validations.Generic.FilterConditionNotContainsConditionNumbers')));
  });

export const dateIsEqualOrLessThanGivenDate = date =>
  Validator(function dateIsEqualOrLessThanGivenDate(x) {
    if (date && x) {
      return moment(x).isSameOrBefore(new Date(date), 'day')
        ? Success
        : Failure(ValidationError(i18next.t('Validations.Generic.StartDateMustbeBeforeEndDate')));
    }
    return Success;
  });

export const dateIsEqualOrGreaterThanGivenDate = date =>
  Validator(function dateIsEqualOrGreaterThanGivenDate(x) {
    if (date && x) {
      return moment(x).isSameOrAfter(new Date(date), 'day')
        ? Success
        : Failure(ValidationError(i18next.t('Validations.Generic.EndDateMustbeAfterStartDate')));
    }
    return Success;
  });

export const oneFieldShouldBeCompleted = (fields, validationMessageTranslationKey) =>
  Validator(content => {
    if (!fields || fields?.length === 0) return;

    let fullfilledFields = 0;
    Object.keys(content).forEach(key => {
      if (fields.indexOf(key) > -1) {
        if (content[key] !== undefined && content[key] !== null) fullfilledFields += 1;
      }
    });
    return fullfilledFields > 1 ? Failure(ValidationError(i18next.t(validationMessageTranslationKey))) : Success;
  });
